import React from 'react';
import { Alert, Button } from 'antd';
import { AxiosError } from 'axios';
import { Link } from 'react-router-dom';

export const MatchingReadError = ({
  error,
  retained = false,
  detail = false,
  onRetry,
  backTo,
}: {
  error: unknown;
  retained?: boolean;
  detail?: boolean;
  onRetry: () => void;
  // Only a detail page has a list to return to.
  backTo?: string;
}) => {
  if (!error) return null;
  const status = (error as AxiosError).response?.status;
  if (status === 401) return null; // Session expiry is handled globally.
  const message =
    status === 404
      ? detail
        ? 'Candidate or project not found'
        : 'This record is no longer available'
      : status === 403
      ? 'You do not have permission to view these matches'
      : status === 400
      ? detail
        ? 'This match link is invalid'
        : 'These filters could not be applied'
      : 'Matches could not be loaded';
  // An invalid link or a missing source cannot succeed on retry.
  const permanent = !!backTo && (status === 400 || status === 404);
  return (
    <Alert
      type="error"
      showIcon
      message={message}
      description={
        permanent
          ? retained
            ? 'The last loaded assessment is still shown, but it can no longer be reloaded. Return to the matches list.'
            : 'Return to the matches list to choose another match.'
          : retained
          ? 'The last loaded results are still shown. They may have changed since your last visit.'
          : 'Try again, or return to the previous page.'
      }
      action={
        backTo && permanent ? (
          <Link to={backTo}>Back to matches</Link>
        ) : (
          <Button onClick={onRetry} size="small">
            Try again
          </Button>
        )
      }
    />
  );
};
